import { render } from "./ParcelasPedidoExpedidoFaturado.vue?vue&type=template&id=21c36ac4&scoped=true"
import script from "./ParcelasPedidoExpedidoFaturado.vue?vue&type=script&lang=js"
export * from "./ParcelasPedidoExpedidoFaturado.vue?vue&type=script&lang=js"

import "./ParcelasPedidoExpedidoFaturado.vue?vue&type=style&index=0&id=21c36ac4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c36ac4"]])

export default __exports__